/**
 * "Complete Your Stack" cart-drawer upsell driver.
 *
 * Must live in an external file (not an inline section script): Dawn re-renders
 * the drawer via renderContents() -> innerHTML, and inline <script> tags injected
 * through innerHTML never execute. So population is driven here, on load AND on
 * every PUB_SUB_EVENTS.cartUpdate, mirroring cart-progress.js.
 *
 * Reads the seed + exclude list from the authoritative cart, fetches product
 * recommendations (complementary, falling back to related), and renders up to
 * two tiles into #CartUpsellItems. Re-runs after every cart change.
 */
(function () {
  if (window.__htcCartUpsellBound) return;
  window.__htcCartUpsellBound = true;

  var MAX_TILES = 2;
  var inflightCart = null;

  function rootUrl() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function looksLikeFullCart(o) {
    return o && typeof o.item_count === 'number' && Array.isArray(o.items);
  }

  function fetchCart() {
    if (inflightCart) return inflightCart;
    inflightCart = fetch(rootUrl() + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .catch(function () { return null; })
      .then(function (c) { inflightCart = null; return c; });
    return inflightCart;
  }

  function escapeAttr(s) {
    return String(s == null ? '' : s).replace(/"/g, '&quot;');
  }

  function loadRecommendations(seedId, excludeIds) {
    var base = rootUrl() + 'recommendations/products.json?product_id=' + seedId + '&limit=6&intent=';
    return fetch(base + 'complementary')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var prods = ((data && data.products) || []).filter(function (p) { return excludeIds.indexOf(p.id) === -1; });
        if (prods.length) return prods;
        return fetch(base + 'related')
          .then(function (r) { return r.json(); })
          .then(function (d2) { return ((d2 && d2.products) || []).filter(function (p) { return excludeIds.indexOf(p.id) === -1; }); });
      })
      .catch(function () { return []; });
  }

  function tileHtml(product) {
    var variant = product.variants && product.variants[0];
    if (!variant) return '';
    var img = product.featured_image || (product.images && product.images[0]) || '';
    var imgUrl = img ? img.replace(/(\.[^./]+)(\?|$)/, '_120x120$1$2') : '';
    if (imgUrl.indexOf('//') === 0) imgUrl = 'https:' + imgUrl;
    var price = (variant.price / 100).toFixed(2);
    var titleAttr = escapeAttr(product.title);
    return '<div class="htc-cart-upsell__item">' +
      (imgUrl ? '<a href="' + product.url + '" class="htc-cart-upsell__img"><img src="' + imgUrl + '" alt="' + titleAttr + '" loading="lazy" width="60" height="60"></a>' : '') +
      '<div class="htc-cart-upsell__details">' +
        '<a href="' + product.url + '" class="htc-cart-upsell__name">' + product.title + '</a>' +
        '<span class="htc-cart-upsell__price">$' + price + '</span>' +
      '</div>' +
      '<button class="htc-cart-upsell__add" type="button" data-variant-id="' + variant.id + '" aria-label="Add ' + titleAttr + '">' +
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>' +
      '</button>' +
    '</div>';
  }

  function onAddClick() {
    var variantId = this.getAttribute('data-variant-id');
    if (!variantId) return;
    var btn = this;
    btn.disabled = true;
    btn.classList.add('htc-cart-upsell__add--added');
    btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';

    var cartContainer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var sections = [];
    if (cartContainer && typeof cartContainer.getSectionsToRender === 'function') {
      try { sections = cartContainer.getSectionsToRender().map(function (s) { return s.id; }); } catch (e) { sections = []; }
    }
    var body = { items: [{ id: parseInt(variantId, 10), quantity: 1 }] };
    if (sections.length) { body.sections = sections.join(','); body.sections_url = window.location.pathname; }

    fetch(rootUrl() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        try {
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-upsell', cartData: data });
          }
        } catch (e) { /* swallow */ }
        if (cartContainer && typeof cartContainer.renderContents === 'function' && data && data.sections) {
          cartContainer.renderContents(data);
        }
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      })
      .catch(function () {
        btn.disabled = false;
        btn.classList.remove('htc-cart-upsell__add--added');
      });
  }

  function populate(cart) {
    var wrap = document.querySelector('cart-drawer .htc-cart-upsell, .htc-cart-upsell');
    if (!wrap) return;
    var container = wrap.querySelector('#CartUpsellItems') || document.getElementById('CartUpsellItems');
    if (!container) return;

    if (!cart || !cart.items || !cart.items.length) { wrap.style.display = 'none'; return; }

    var seedId = cart.items[0].product_id;
    var excludeIds = cart.items.map(function (it) { return it.product_id; });

    loadRecommendations(seedId, excludeIds).then(function (products) {
      var picks = (products || []).slice(0, MAX_TILES);
      if (!picks.length) { wrap.style.display = 'none'; return; }

      container.innerHTML = picks.map(tileHtml).join('');
      wrap.style.display = '';
      container.querySelectorAll('.htc-cart-upsell__add').forEach(function (b) {
        b.addEventListener('click', onAddClick);
      });
    });
  }

  function refresh(cartData) {
    if (looksLikeFullCart(cartData)) { populate(cartData); return; }
    fetchCart().then(populate);
  }

  function init() {
    refresh();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) { refresh(event && event.cartData); });
    }
    document.addEventListener('cart:refresh', function () { refresh(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
